export default "/images/6d16e24f9e500b5cc379ffa705905dde.avif";